import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=49042c9b&"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts&"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports